import { render } from "./partial-router-view-error.vue?vue&type=template&id=72e25af4&ts=true"
import script from "./partial-router-view-error.vue?vue&type=script&lang=ts"
export * from "./partial-router-view-error.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__